// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: 'Segoe UI', sans-serif;
  background: #f4f4f4;
  margin: 0;
  padding: 2rem;
  color: #333;
}

.resume {
  max-width: 800px;
  margin: auto;
  background: #fff;
  padding: 2rem;
  box-shadow: 0 0 10px rgba(0,0,0,0.1);
}

header h1 {
  margin: 0;
  font-size: 2rem;
  color: #005a9c;
}

header h2 {
  margin-top: 0.5rem;
  font-weight: normal;
  color: #444;
}

.contact {
  margin-top: 0.5rem;
  font-size: 0.9rem;
  color: #666;
}

.contact a {
  color: #005a9c;
  text-decoration: none;
}

section {
  margin-top: 2rem;
}

section h3 {
  border-bottom: 2px solid #005a9c;
  padding-bottom: 0.3rem;
  margin-bottom: 1rem;
  color: #005a9c;
}

.job h4 {
  margin: 0;
  font-size: 1.1rem;
  color: #333;
  text-align: left;
}

.job p span {
  float: right;
  font-style: italic;
  color: #666;
  text-align: left;
}

ul {
  margin-top: 0.5rem;
  padding-left: 1.2rem;
  text-align: left;
}

ul li {
  margin-bottom: 0.5rem;
  text-align: left;
}

a:hover {
  text-decoration: underline;
}

p {
  margin-bottom: 0.5rem;
  text-align: left;
}


`, "",{"version":3,"sources":["webpack://./src/components/Resume.css"],"names":[],"mappings":"AAAA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,oCAAoC;AACtC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB","sourcesContent":["body {\n  font-family: 'Segoe UI', sans-serif;\n  background: #f4f4f4;\n  margin: 0;\n  padding: 2rem;\n  color: #333;\n}\n\n.resume {\n  max-width: 800px;\n  margin: auto;\n  background: #fff;\n  padding: 2rem;\n  box-shadow: 0 0 10px rgba(0,0,0,0.1);\n}\n\nheader h1 {\n  margin: 0;\n  font-size: 2rem;\n  color: #005a9c;\n}\n\nheader h2 {\n  margin-top: 0.5rem;\n  font-weight: normal;\n  color: #444;\n}\n\n.contact {\n  margin-top: 0.5rem;\n  font-size: 0.9rem;\n  color: #666;\n}\n\n.contact a {\n  color: #005a9c;\n  text-decoration: none;\n}\n\nsection {\n  margin-top: 2rem;\n}\n\nsection h3 {\n  border-bottom: 2px solid #005a9c;\n  padding-bottom: 0.3rem;\n  margin-bottom: 1rem;\n  color: #005a9c;\n}\n\n.job h4 {\n  margin: 0;\n  font-size: 1.1rem;\n  color: #333;\n  text-align: left;\n}\n\n.job p span {\n  float: right;\n  font-style: italic;\n  color: #666;\n  text-align: left;\n}\n\nul {\n  margin-top: 0.5rem;\n  padding-left: 1.2rem;\n  text-align: left;\n}\n\nul li {\n  margin-bottom: 0.5rem;\n  text-align: left;\n}\n\na:hover {\n  text-decoration: underline;\n}\n\np {\n  margin-bottom: 0.5rem;\n  text-align: left;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
